<script setup lang="ts">
import {computed, watch} from "vue";
import {useUrlSearchParams} from "@vueuse/core";
import {useSearchParam} from "@/service/searchInputParam.service.ts";
import {usePaginationParams} from "@/service/paginationParams.service.ts";
import {provideLoadingIndicator} from "@/service/loadingIndicator.service.ts";
import {provideSearchPageReload} from "@/service/searchPageReload.service.ts";
import {fetchHtmlPage, type HtmlPageResult} from "@/service/fetchHtmlPage.ts";
import SearchPageBase from "@/components/SearchPageBase.vue";

provideLoadingIndicator()
const {reloadFirstPage} = provideSearchPageReload()

const urlSearchParams = useUrlSearchParams<Record<string, string>>("history", {removeFalsyValues: true})

const {search, searchInput, submitSearch} = useSearchParam(computed({
  get: () => urlSearchParams.q || '',
  set: q => urlSearchParams.q = q,
}))

const {pageNumber, pageSize} = usePaginationParams(urlSearchParams, {defaultPageSize: 20})

watch(search, reloadFirstPage)

function loadStores(): Promise<HtmlPageResult> {
  const params = new URLSearchParams()
  params.set('_page', String(pageNumber.value))
  params.set('_size', String(pageSize.value))

  if (search.value) params.set('q', search.value)

  return fetchHtmlPage('/api/products', params)
}
</script>

<template>
  <SearchPageBase
      search-placeholder="Suche nach Produkten"
      v-model:page-number="pageNumber"
      v-model:page-size="pageSize"
      v-model:search="searchInput"
      :load-page="loadStores"
      @submit-search="submitSearch"
  >
    <template #searchForm>
      <!-- Filter stuff here -->
    </template>
    <template #noneFound>
      <h2>Keine Produkte gefunden</h2>
    </template>
  </SearchPageBase>
</template>
